var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZapFast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-stroke/zap-fast"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.5 26.25H5.25M9.75 18H3M13.5 9.75H6M25.5 4.5L15.6053 18.3525C15.1674 18.9656 14.9484 19.2722 14.9579 19.5278C14.9662 19.7503 15.0729 19.9577 15.2491 20.0937C15.4516 20.25 15.8284 20.25 16.5818 20.25H24L22.5 31.5L32.3947 17.6475C32.8326 17.0344 33.0516 16.7278 33.0421 16.4722C33.0338 16.2497 32.9271 16.0423 32.7509 15.9063C32.5484 15.75 32.1716 15.75 31.4182 15.75H24L25.5 4.5Z",
    stroke: "#46C3B2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFast);
export default __webpack_public_path__ + "static/media/zap-fast.e4324a04e2b37145fca6fd0e9db9e2c0.svg";
export { ForwardRef as ReactComponent };